"use client";

import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Title } from "@/ui";
import classes from "./styles.module.scss";

export default function GridBox({ sectionId, className, bgColor, title, titleColor, items, description }) {
  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.GridBox)}>
      <Container>
        <Title title={title} className={clsx(titleColor, "mb-4")} />
        <div className="desc" dangerouslySetInnerHTML={{ __html: description }} />
        <Row>
          {items?.length > 0 ? (
            items.map((item, index) => {
              const Wrapper = item?.href ? "a" : "div";

              return (
                <Col lg={3} md={6} key={index} className="my-3">
                  <Wrapper href={item?.href} className={classes.tile}>
                    <figure className="object_fit">
                      <img
                        src={item?.image?.url || "/assets/home/placeholder-image.jpeg"}
                        alt={item?.image?.alt || "Image"}
                        className="w-100"
                      />
                    </figure>

                    <div className={classes.tileTitle}>{item?.title}</div>
                  </Wrapper>
                </Col>
              );
            })
          ) : (
            <Col>
              <div className={classes.emptyState}>No items available</div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
